var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"wrapper",attrs:{"id":"full-wrapper"}},[_c('div',{attrs:{"id":"full-container"}},[_c('div',{ref:"editor"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }